import type { ReactElement } from 'react';
import { Grid, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import Marquee from 'react-fast-marquee';
import type { MarkdownRemarkFrontmatterPartners } from '../../../generated/types';
import { useBreakpoints } from '../../components/hooks/useBreakpoints';

type PpPartnersSection = {
  partners: MarkdownRemarkFrontmatterPartners[];
};

const StyledStack = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  marginTop: theme.spacing(2),
  position: 'relative',
  zIndex: 3,
})) as typeof Stack;

const StyledImgWrapper = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  height: '100%',
  justifyContent: 'center',
  padding: theme.spacing(1, 4),
}));

export function PartnersSection({ partners }: PpPartnersSection): ReactElement {
  const { isSmall } = useBreakpoints();
  if (isSmall) {
    return (
      <StyledStack component="section">
        <Marquee direction="left">
          {partners.map((partner) => {
            if (!partner.logo || !partner.name) {
              return null;
            }
            return (
              <StyledImgWrapper key={partner.id}>
                <img alt={partner.name} src={partner.logo} />
              </StyledImgWrapper>
            );
          })}
        </Marquee>
        <Marquee direction="right">
          {partners.reverse().map((partner) => {
            if (!partner.logo || !partner.name) {
              return null;
            }
            return (
              <StyledImgWrapper key={partner.id}>
                <img alt={partner.name} src={partner.logo} />
              </StyledImgWrapper>
            );
          })}
        </Marquee>
      </StyledStack>
    );
  }
  return (
    <StyledStack component="section">
      <Grid container columns={10} maxWidth="md">
        {partners.map((partner) => {
          if (!partner.logo || !partner.name) {
            return null;
          }
          return (
            <Grid key={partner.id} size={{ md: 2 }}>
              <StyledImgWrapper key={partner.id}>
                <img alt={partner.name} src={partner.logo} />
              </StyledImgWrapper>
            </Grid>
          );
        })}
      </Grid>
    </StyledStack>
  );
}
